export const isHideCombosActiveKey: InjectionKey<ComputedRef<boolean>> =
  Symbol('isHideCombosActive')

export const isTaxCatalogActiveKey: InjectionKey<ComputedRef<boolean>> =
  Symbol('isTaxCatalogActive')
